var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container1"},[_c('div',{staticClass:"ct-index1"},[_c('div',{staticClass:"inner1"},[_c('el-empty',{attrs:{"description":"权限不足"}},[_c('div',[_vm._v("您当前IP为："+_vm._s(this.$route.query.ip)+"，如需开通使用请联系客服QQ：1044423649")])])],1)]),_vm._v(" "),_c('div',[_c('common-foot')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b34586a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/Empty.vue
// module id = null
// module chunks = 